import { render, staticRenderFns } from "./NewLanguePopup.vue?vue&type=template&id=9659c92e&"
import script from "./NewLanguePopup.vue?vue&type=script&lang=js&"
export * from "./NewLanguePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports